import { type GetHookResponse } from '../hooks'
import { exportDownloadKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type ExportDownloadInput, type ExportDownloadSuccess } from '@terros/common'

export function useExportDownload(input: ExportDownloadInput): GetHookResponse<ExportDownloadSuccess> {
  return useTantalimQuery<ExportDownloadInput, ExportDownloadSuccess, ExportDownloadSuccess>({
    url: '/export/download',
    queryKey: exportDownloadKey(input),
    input,
    convertResponse: (data) => data,
    options: {
      staleTime: 0,
      gcTime: 0,
    },
  })
}
